import { render } from "./QRAvatarComponent.vue?vue&type=template&id=35c19597&ts=true"
import script from "./QRAvatarComponent.vue?vue&type=script&lang=ts"
export * from "./QRAvatarComponent.vue?vue&type=script&lang=ts"

import "./QRAvatarComponent.vue?vue&type=style&index=0&id=35c19597&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__